import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cn-copy-card-details-popup',
  templateUrl: './cn-copy-card-details-popup.component.html',
  styleUrls: ['./cn-copy-card-details-popup.component.scss']
})
export class CnCopyCardDetailsPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
